import { FormControl, FormGroup } from '@angular/forms';
import { PolygonMapItem } from '../polygon-map-item';
import { RegisterElement } from '../../element-decorator';
import { PropertyMetadata } from '../../../properties/property-types';

@RegisterElement()
export class GardenBed extends PolygonMapItem {
    public override TypeName: string = 'GardenBed';
    protected sizeInMeters: number = 2;

    constructor(formGroup: FormGroup) {
        super(formGroup, "GardenBed");
        
        if (!formGroup.contains('Name')) {
            formGroup.addControl('Name', new FormControl(''));
        }
    }

    public override clone(): GardenBed {
        return new GardenBed(this.formGroup);
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            {
                formControlName: 'Name',
                displayName: 'Name',
                inputType: { type: 'text' },
                order: 1,
                category: 'General'
            }
        ];
    }

    public override default(): GardenBed {
        return this;
    }
} 
